import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TaskLabel } from '@demind-inc/core';

import { API_URL, axiosInstance, tasksApi } from '../api';

interface UseDeleteTaskLabelParams {
  taskLabelGroupId: string;
  labelId: string;
}

export const useDeleteTaskLabel = () => {
  const queryClient = useQueryClient();

  const deleteTaskLabelMutation = useMutation({
    mutationFn: ({ taskLabelGroupId, labelId }: UseDeleteTaskLabelParams) =>
      tasksApi.deleteTaskLabel(taskLabelGroupId, labelId).then(({ data }) => data),
    onSuccess: (_data, { taskLabelGroupId, labelId }) => {
      const labelsQueryKey = ['lifestack.todo.tasks.labels', { taskLabelGroupId }] as const;

      queryClient.setQueriesData<TaskLabel[]>({ queryKey: labelsQueryKey }, (prevLabels) =>
        prevLabels?.filter((label) => label.id !== labelId)
      );

      queryClient.invalidateQueries({ queryKey: labelsQueryKey });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.tasks.labels'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.tasks'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.overdueTasks'] });
    },
  });

  return {
    ...deleteTaskLabelMutation,
    deleteTaskLabel: deleteTaskLabelMutation.mutateAsync,
  };
};
